import 'react-app-polyfill/ie11';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'core-js/stable/array/find';
import 'core-js/stable/array/includes';
import 'core-js/stable/number/is-nan';
import 'regenerator-runtime/runtime'